import { render, staticRenderFns } from "./atc-chart.vue?vue&type=template&id=53e9f8d5"
import script from "./atc-chart.ts?vue&type=script&lang=ts&external"
export * from "./atc-chart.ts?vue&type=script&lang=ts&external"
import style0 from "./atc-chart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports